import { Component } from "@angular/core";
import { FuseAlertAppearance, FuseAlertType } from "../../alert";

@Component({
    selector: "alert-storybook",
    templateUrl: "./alert-storybook.component.html",
})
export class AlertStorybookComponent {
    appearances: FuseAlertAppearance[] = [ "border", "fill", "soft"];

    allTypes: FuseAlertType[] = ["warn", "warning", "primary", "basic", "accent", "info", "success", "error"];

    figmaTypes: FuseAlertType[] = ["warn", "warning", "primary", "basic"];

    otherTypes: FuseAlertType[] = ["accent", "info", "success", "error"];
}
